<template>
  <section class="tables new-updated-design">
    <vue-snotify></vue-snotify>
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">View Members</h4>
          </div>
          <div class="card-body">
            <div class="panel-heading">
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-6 form-group">
                  <input
                    type="hidden"
                    name="autocompletePractice"
                    id="autocompletePractice"
                  />

                  <input
                    class="form-control"
                    v-model="serverParams.customFilters.name"
                    type="text"
                    name="search"
                    id="search"
                    placeholder="Search"
                    value=""
                    @keyup="loadItems()"
                  />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 form-group">
                  <select
                    class="form-control"
                    v-model="serverParams.customFilters.status"
                    name="Status"
                    @change="loadItems()"
                  >
                    <option value="">Select User Status</option>
                    <option value="all">All</option>
                    <option value="PDC">PDC</option>
                    <option value="PCA">PCA</option>
                    <option value="CA">CA</option>
                    <option value="DC">DC</option>
                  </select>
                </div>
                <div
                  class="col-lg-4 col-md-4 col-sm-6 form-group"
                  style="font-size: 15px; font-weight: 300"
                >
                  <input
                    class="group"
                    name="group"
                    value="Active"
                    type="radio"
                    @click="radioFilter('Active')"
                  />
                  Currents
                  <input
                    class="group"
                    name="group"
                    value="Inactive"
                    type="radio"
                    @click="radioFilter('Inactive')"
                  />
                  Pasts
                  <input
                    class="group"
                    name="group"
                    value="Suspended"
                    type="radio"
                    @click="radioFilter('Suspended')"
                  />
                  Futures
                </div>
                <div class="col-lg-2 col-md-4 col-sm-6 form-group">
                  <vue-json-to-csv :json-data="CSVData">
                    <a
                      class="btn btn-success btn-xs btn-rounded p-l-10 p-r-10"
                      href="#"
                      >Export to CSV</a
                    >
                  </vue-json-to-csv>
                </div>

                <div
                  class="col-lg-2 col-md-4 col-sm-6 form-group"
                  style="font-size: 13px; font-weight: 300; margin-top: 1%"
                >
                  <input
                    name="reset"
                    type="reset"
                    value="Reset"
                    class="btn btn-success btn-xs btn-rounded p-l-10 p-r-10"
                    @click="resetMemberData()"
                  />
                </div>
              </div>
            </div>
            <CircleLoader v-if="isLoading" />
            <vue-good-table
              mode="remote"
              :totalRows="totalRecords"
              :isLoading="isLoading"
              :pagination-options="{
                enabled: true,
                perPage: serverParams.perPage,
                perPageDropdown: [10, 20, 50, 100, 200],
              }"
              :sort-options="{
                enabled: true,
                initialSortBy: {
                  field: 'PracticeID',
                  type: 'desc',
                },
              }"
              :rows="rows"
              :columns="columns"
              @on-page-change="onPageChange"
              @on-per-page-change="onPerPageChange"
              @on-sort-change="onSortChange"
            >
              <template slot="table-row" slot-scope="props">
                <span
                  v-if="props.column.field === 'action'"
                  class="text-nowrap"
                >
                  <!-- <toggle-button
                    v-model="
                      spots.find((p) => p.spot_id === props.row.UserID)
                        .spot_status
                    "
                    @change="changeStatus(props.row.UserID, $event)"
                    :sync="true"
                    color="#070708"
                    class="mr-1"
                  /> -->
                  <b-button
                    size="sm"
                    @click="editMember(props.row)"
                    class="mr-1 btn-info text-white"
                  >
                    Edit
                  </b-button>
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <div></div>
  </section>
</template>

<script>
import Vue from "vue";
import VueJsonToCsv from "vue-json-to-csv";
import SortedTablePlugin from "vue-sorted-table";
import API from "@/api";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  email,
  requiredIf,
  sameAs,
} from "vuelidate/lib/validators";
import moment from "moment";
import CircleLoader from "@/pages/loaders/CircleLoader.vue";
Vue.component("vue-json-to-csv", VueJsonToCsv);
Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="ti-arrow-down"></i>',
  descIcon: '<i class="ti-arrow-up"></i>',
});
export default {
  name: "Spotters",
  mixins: [validationMixin],
  data() {
    return {
      serverParams: {
        customFilters: {
          status: "",
          memberStatus: "",
          name: "",
        },
        sort: [
          {
            field: "PracticeID", // example: 'name'
            type: "desc", // 'asc' or 'desc'
          },
        ],

        page: 1, // what page I want to show
        perPage: 10, // how many items I'm showing per page
      },
      columns: [
        {
          label: "Practice",
          field: "PracticeName",
          filterable: false,
        },
        {
          label: "Position",
          field: "Status",
          sortable: true,
        },
        {
          label: "Email",
          field: "email",
          sortable: true,
        },
        {
          label: "Name",
          field: "Name",
          sortable: true,
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
        },
      ],
      isLoading: false,
      rows: [],
      totalRecords: 0,
      spots: [
        {
          spot_id: 0,
          spot_status: false,
        },
      ],
      CSVData: [],
    };
  },
  methods: {
    editMember(member) {
      this.$router.push({
        name: "edit_Member",
        params: { id: member.UserID, user: member },
      });
    },
    radioFilter(value) {
      this.serverParams.customFilters.memberStatus = value;
      this.loadItems();
    },
    resetMemberData() {
      this.serverParams.customFilters.memberStatus = "";
      this.serverParams.customFilters.status = "";
      this.serverParams.customFilters.name = "";
      this.loadItems();
    },
    loadItems() {
      this.isLoading = true;
      API.getAllMembers(
        this.serverParams,
        (data) => {
          this.totalRecords = data.totalRecords;
          this.rows = data.data;
          this.CSVData = [];
          this.spots = [];
          this.rows.map((q) => {
            const DataForCSV = q
              ? {
                  Position: q.Status,
                  Username: q.FirstName + " " + q.LastName,
                  MemberStatus: q.MemberStatus,
                  Email: q.email,
                  Address1: q.Address1,
                  Address2: q.Address2,
                  City: q.City,
                  State: q.StateID,
                  Phone1: q.Phone1,
                  Phone2: q.Phone2,
                }
              : {};
            const sp = {
              spot_id: q ? q.UserID : 0,
              spot_status: q ? q.MemberStatus === "Active" : false,
            };
            this.CSVData.push(DataForCSV);
            this.spots.push(sp);
          });
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
        }
      );
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },
    onPerPageChange(params) {
      if (params.currentPerPage !== this.serverParams.perPage) {
        this.updateParams({ perPage: params.currentPerPage });
        this.loadItems();
      }
    },
    changeStatus(spot_id, event) {
      const data = {
        id: spot_id,
        status: event.value === true ? "Active" : "Inactive",
      };
      API.updateMemberStatus(
        data,
        (data) => {
          if (data.status === 200) {
            this.$showNotification(data, "success");
          }
        },
        (err) => {
          console.log(err);
          this.$showNotification({ message: "Failed system error" }, "error");
        }
      );
    },
    onSortChange(params) {
      Vue.set(this.serverParams.sort, 0, {
        field: params[0].field,
        type: params[0].type,
      });
      // this.loadItems();
    },
  },
  computed: {},
  mounted() {
    this.loadItems();
  },
};
</script>
